<div class="app-titulo-pagina-v2">
  <img src="../../../../assets/img/icons/bt_senha_eletrônica_roxo.png" alt="Icone de btn_cadastros">
  <span>Redefinir Senha Eletrônica</span>
</div>

<div *ngIf="processando" class="text-center" style="margin-top: 150px;">
  <i class="fa fa-spinner fa-pulse fa-4x"></i>
</div>
<div *ngIf="!processando">
  <div class="container">
    <div class="alert alert-warning" role="alert" style="margin-top: 10px;">
      <h4>Atenção!</h4>
      <p>Caso você tenha esquecido sua senha eletrônica, é possivel atribuir uma nova!</p>
      <p>Para atribuir uma nova senha, clique no botão abaixo. Dentro de alguns minutos, você receberá uma mensagem com o código
        de segurança no endereço de email cadastrado pelo seu Gestor.</p>
    </div>

    <div class="col-xs-12 text-center form-group">
      <button (click)="resetEPwd()" type="button" class="btn btn-warning">
        <i class="fa fa-envelope"></i> Gerar Código de Segurança
      </button>
    </div>
  </div>

  <div class="container">
    <form (submit)="saveEPwd()" class="col-xs-12 col-md-12" ngNativeValidate>
      <div class="panel panel-default app-panel">
        <div class="panel-heading"> Redefinir Senha Eletrônica
        </div>
        <div class="panel-body">
          <div class="form-group col-xs-12 col-md-8 col-md-offset-2">
            <label for="codigoSeguranca">Código de Segurança</label>
            <input type="text" id="codigoSeguranca" name="codigoSeguranca" [(ngModel)]="epwd.codigoSeguranca" class="form-control input-sm input-sm"
              maxlength="256" required>
          </div>

          <div class="form-group col-xs-12 col-md-8 col-md-offset-2">
            <label for="novaSenha">Nova Senha Eletrônica</label>
            <input type="password" id="novaSenha" [(ngModel)]="epwd.nova" name="nova" class="form-control input-sm input-sm" maxlength="256"
              required>
          </div>

          <div class="form-group col-xs-12 col-md-8 col-md-offset-2">
            <label for="confirmacaoSenha">Confirmação da Nova Senha Eletrônica</label>
            <input type="password" id="confirmacaoSenha" name="confirmacaoSenha" [(ngModel)]="epwd.confirmacao" name="confirmacao" class="form-control input-sm input-sm"
              maxlength="256" required>
          </div>

          <div class="col-xs-12 text-center">
            <a (click)="mainService.loginService.changeRoute('/cartao/epwd')" id="btnVoltar" class="btn btn-danger-v2" style="margin-right: .5em;">
              Voltar</a>
            <button type="submit" class="btn btn-success-v2">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>

</div>


// WEBPACK FOOTER //
// ./src/app/menu-superior/meu-cadastro/epwd-reset/epwd-reset.component.html